var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoNotSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "do-not"
  }, /*#__PURE__*/React.createElement("path", {
    id: "do--not_1_",
    d: "M16,31.36C7.53,31.36,0.64,24.469,0.64,16S7.531,0.64,16,0.64S31.36,7.53,31.36,16S24.47,31.36,16,31.36z M16,1.36C7.928,1.36,1.36,7.927,1.36,16c0,8.072,6.567,14.64,14.64,14.64c8.072,0,14.639-6.567,14.639-14.64 C30.64,7.927,24.072,1.36,16,1.36z M20.987,23.36c-0.636,0-1.232-0.246-1.68-0.693L16,19.358l-3.308,3.309 c-0.894,0.896-2.465,0.894-3.359,0c-0.447-0.447-0.693-1.044-0.693-1.68s0.246-1.232,0.693-1.68L12.641,16l-3.308-3.308 c-0.926-0.926-0.926-2.433,0-3.358s2.434-0.927,3.359,0L16,12.641l3.307-3.307c0.896-0.895,2.466-0.894,3.359,0 c0.447,0.447,0.693,1.043,0.693,1.679s-0.246,1.232-0.693,1.68L19.359,16l3.308,3.308c0.447,0.447,0.693,1.043,0.693,1.68 s-0.246,1.232-0.693,1.68S21.624,23.36,20.987,23.36z M16,18.489c0.096,0,0.187,0.038,0.254,0.105l3.562,3.562 c0.622,0.624,1.721,0.623,2.34,0c0.312-0.311,0.483-0.727,0.483-1.17s-0.172-0.859-0.483-1.17l-3.562-3.563 c-0.141-0.141-0.141-0.368,0-0.509l3.562-3.562c0.312-0.311,0.483-0.727,0.483-1.17s-0.172-0.859-0.483-1.17 c-0.619-0.621-1.718-0.624-2.34,0l-3.562,3.562c-0.141,0.141-0.368,0.141-0.509,0l-3.562-3.562c-0.623-0.623-1.72-0.622-2.341,0 c-0.645,0.646-0.645,1.695,0,2.341l3.562,3.562c0.141,0.141,0.141,0.368,0,0.509l-3.562,3.563c-0.311,0.311-0.482,0.727-0.482,1.17 s0.171,0.859,0.482,1.17c0.621,0.622,1.718,0.623,2.341,0l3.562-3.562C15.813,18.527,15.905,18.489,16,18.489z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoNotSvgrepoCom);
export default __webpack_public_path__ + "static/media/do-not-svgrepo-com.a500112084fba9e5bda6b719d9adb71a.svg";
export { ForwardRef as ReactComponent };